export const DOWNSTREAM_CANVAS_SEMANTIC_SEARCH_ENABLED = false;
export const SEMANTIC_MODEL_GROUP_SIZE = 10;
export const APP_TOKEN_KEY = "token";
export const CART_SOCKET_HOST = "http://localhost:8001";
export const CART_SOCKET_PATH = "/socket.io";
